"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GiftBoxCircleLinear = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var GiftBoxCircleLinear = function GiftBoxCircleLinear(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.389 14.379c-.654.627-1.105 1.502-1.424 2.428-.291-.752-.695-1.46-1.264-2.02-1.328-1.307-2.793-1.631-4.037-1.411a4.15 4.15 0 00-1.56.62c-.392.26-.753.604-.97 1.002a3.01 3.01 0 01-.05.058l-.048.055c-.098.113-.257.3-.391.545-.309.563-.404 1.284-.022 2.122.346.759 1.065 1.58 2.257 2.536.63.505 1.414 1.064 2.384 1.686h-5.082C19.508 22 18 23.263 18 25v5.691a1 1 0 100 2V40c0 1.737 1.508 3 3.182 3h18.545c1.674 0 3.182-1.263 3.182-3v-7.891a.996.996 0 000-.835V25c0-1.737-1.508-3-3.182-3h-6.075a21.875 21.875 0 002.322-1.725c1.177-1.02 1.86-1.94 2.146-2.802.305-.92.127-1.684-.213-2.247-.292-.484-.76-.852-.755-.847l-.03-.03c-.34-.327-1.053-1.013-2.052-1.258-1.143-.28-2.402.06-3.681 1.288zm1.385 1.442c.91-.873 1.495-.867 1.82-.787.439.107.807.436 1.173.787.072.069.13.12.18.164.106.092.173.151.248.276.063.104.132.263.026.583-.125.377-.51 1.012-1.557 1.92-.791.686-1.922 1.495-3.516 2.438.062-.64.147-1.333.274-2.023.281-1.527.726-2.757 1.352-3.358zm-4.2 3.54c.106.63.17 1.255.215 1.844-1.643-.973-2.822-1.781-3.658-2.451-1.103-.885-1.535-1.47-1.688-1.805-.107-.235-.063-.302-.048-.327l.003-.005c.026-.046.066-.1.149-.195l.023-.027c.034-.038.081-.092.12-.14.048-.059.132-.166.201-.302a.534.534 0 01.078-.095c.057-.059.137-.127.24-.196.21-.139.487-.26.804-.317.594-.105 1.409.005 2.286.868.643.633 1.044 1.763 1.276 3.148zM29 30.691V24h-7.818c-.737 0-1.182.528-1.182 1v5.691h9zM20 40v-7.309h8.998L28.918 41h-7.736C20.445 41 20 40.472 20 40zm10.919 1l.08-8.309h9.91V40c0 .472-.445 1-1.182 1H30.92zm9.99-16v5.691H31V24h8.727c.737 0 1.182.528 1.182 1zM22.15 14.979l-.002.003.003-.003z",
    fill: "url(#GiftBoxCircleLinear_svg__GiftBoxCircleLinear_svg__paint0_linear_17373_95601)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30zm0-1.872C14.466 58.128 1.872 45.534 1.872 30S14.466 1.872 30 1.872 58.128 14.466 58.128 30 45.534 58.128 30 58.128z",
    fill: "url(#GiftBoxCircleLinear_svg__GiftBoxCircleLinear_svg__paint1_linear_17373_95601)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "GiftBoxCircleLinear_svg__GiftBoxCircleLinear_svg__paint0_linear_17373_95601",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GiftBoxCircleLinear_svg__GiftBoxCircleLinear_svg__paint1_linear_17373_95601",
    x1: 0,
    y1: 60,
    x2: 63.502,
    y2: 56.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.GiftBoxCircleLinear = GiftBoxCircleLinear;
var _default = GiftBoxCircleLinear;
exports.default = _default;